export function isObject(obj: unknown): boolean {
  return !!obj && !Array.isArray(obj) && typeof obj === 'object';
}
